export const FIELD_TYPES = {
  COST: "COST",
  MEDICAL: "MEDICAL",
  DATA_MANAGEMENT: "DATA_MANAGEMENT",
  VISIT: "VISIT",
};

export const FIELD_TYPE_OPTIONS = [
  { value: FIELD_TYPES.VISIT, label: "Visit" },
  { value: FIELD_TYPES.COST, label: "Cost" },
  { value: FIELD_TYPES.MEDICAL, label: "Clinical Strategy" },
  { value: FIELD_TYPES.DATA_MANAGEMENT, label: "Data Management" },
];

export const VISIT_REQUIRED_FIELDS = {
  visitCategory: true,
  visitName: true,
  visitStudyDay: true,
};

export const ASSESSMENT_REQUIRED_FIELDS = {
  assessmentType: true,
  assessmentName: true,
  assessmentCost: false,
};

export const REQUIRED_FIELDS_ERROR_MESSAGES = {
  visitCategory: "Visit Category is required for each visit entry.",
  visitName: "Visit Name is required and need to be unique for each visit entry.",
  // visitCost: "Visit cost is required for each visit entry.",
  visitStudyDay: (type) => `Visit study ${type} is required.`,
  assessmentType: "Assessment Type is required for each assessment entry.",
  assessmentName: "Assessment Name is required and need to be unique for each assessment entry.",
  assessmentCost: "Assessment cost is required for each assessment entry.",
  assessmentNameType: "Assessment Name Mapping should be empty or be selected from the list.",
};

export const NUMBER_FIELDS = {
  visitCost: true,
  assessmentCost: true,
  visitStudyDay: true,
};

export const UNIQUE_FIELDS = { assessmentName: true, visitName: true };

export const INITIAL_RISK_ASSESSMENT_COLORS = {
  GREEN: "#70AD47",
  RED: "#FF0000",
  YELLOW: "#FFC000",
};

export const VSS_HEADER_COLORS = [
  "5B9BD5",
  "1F4E79",
  "F4B183",
  "F4B183",
  "FFC000",
  "70AD47",
  "00539B",
];

export const VISIT_VARIANCE_TYPE_OPTIONS = [
  { value: "", label: "None" },
  { value: "+", label: "+" },
  { value: "-", label: "-" },
  { value: "+/-", label: "+/-" },
];
export const VISIT_CATEGORY_TYPES = [
  "Screening",
  "Treatment",
  "Follow Up",
  "Close Out",
  "Unscheduled",
];

export const BATCH_SIZE = 50; // Number of visits to load at once

export const SOE_TABLE_MAPPING_PROPERTIES = [
  "assessmentCount",
  "uniqueCRFCount",
  "nonUniqueCRFCount",
];

export const DATA_TABLE_NAME = {
  VISITS_TABLE: "VisitsTable",
  ASSESSMENTS_TABLE: "AssessmentsTable",
  INITIAL_RISK_ASSESSMENT_TABLE: "InitialRiskAssessmentTable",
  VISIT_INFORMATION_TABLE: "VisitInformationTable",
  VISIT_SAMPLE_STRATEGY_TABLES: "VisitSampleStrategyTables",
  CDA_STUDY_TABLE: "CDAStudyTable",
  CRA_TABLE: "CRATable",
  EPRICE_INFO_TABLE: "EPriceInfoTable",
  VARIABLES_TABLE: "VariablesTable",
  IMV_TABLE: "IMVTable",
  CDA_TABLE: "CDATable",
  EPRICE_TABLE: "EPriceTable",
};

// Column width constants for better maintainability
export const VISIT_COUNTRY_COLUMNS_WIDTH = {
  visitCategory: { expanded: "12%", collapsed: "25%" },
  visitName: { expanded: "18%", collapsed: "25%" },
  studyDay: { expanded: "6%", collapsed: "10%" },
  variance: { expanded: "6%", collapsed: "10%" },
  visitWindow: { expanded: "6%", collapsed: "10%" },
  overheadPct: { expanded: "6%", collapsed: "10%" },
  overhead: { expanded: "6%", collapsed: "10%" },
  totalVisitCost: { expanded: "6%", collapsed: "10%" },
  deleteButton: "2%",
};

export const VISIT_STUDY_COLUMNS_WIDTH = {
  visitCategory: { expanded: "16%", collapsed: "30%" },
  visitName: { expanded: "22%", collapsed: "30%" },
  studyDay: { expanded: "8%", collapsed: "13%" },
  variance: { expanded: "7%", collapsed: "13%" },
  visitWindow: { expanded: "7%", collapsed: "14%" },
  deleteButton: "2%",
};

export const ASSESSMENT_STUDY_COLUMNS_WIDTH = {
  assessmentType: "12%",
  assessmentName: "18%",
  assessmentNameMapping: "18%",
  overhead: "8%",
  comments: { editable: "42%", readOnly: "42%" },
  deleteButton: "2%",
};

export const ASSESSMENT_COUNTRY_COLUMNS_WIDTH = {
  assessmentType: "40%",
  assessmentName: "40%",
  assessmentCost: "20%",
};